import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, Users, CalendarCheck, Wrench,
  Receipt, Package, Settings, ChevronLeft, ChevronRight, LogOut, Car
} from 'lucide-react';
import { useAdminAuth } from '../../context/Adminauthcontext';
import './Sidebar.css';

const NAV = [
  { to: '/dashboard',    icon: <LayoutDashboard size={18} />, label: 'Dashboard'       },
  { to: '/appointments', icon: <CalendarCheck size={18} />,   label: 'Appointments'    },
  { to: '/service',      icon: <Wrench size={18} />,          label: 'Service Tracker' },
  { to: '/mechanics',    icon: <Users size={18} />,           label: 'Mechanics'       },
  { to: '/catalogue',    icon: <Package size={18} />,         label: 'Catalogue'       },
  { to: '/history',      icon: <Car size={18} />,             label: 'Car History'     },
  { to: '/billing',      icon: <Receipt size={18} />,         label: 'Billing'         },
  { to: '/inventory',    icon: <Package size={18} />,         label: 'Spare Parts'     },
  { to: '/settings',     icon: <Settings size={18} />,        label: 'Settings'        },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const { admin, logout } = useAdminAuth();

  return (
    <aside className={`sidebar ${collapsed ? 'sidebar--collapsed' : ''}`}>
      {/* Logo */}
      <div className="sidebar__logo">
        <div className="sidebar__logo-icon">
          <img src="/images/logo-icon.png" alt="AutoElite" className="sidebar__logo-img"
            onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='block'; }}/>
          <span style={{ display:'none' }}><Wrench size={16}/></span>
        </div>
        {!collapsed && (
          <div className="sidebar__logo-text">
            <span className="sidebar__logo-name">AutoElite</span>
            <span className="sidebar__logo-sub">Admin Panel</span>
          </div>
        )}
      </div>

      {/* Nav */}
      <nav className="sidebar__nav">
        <div className="sidebar__nav-label">{!collapsed && 'Main Menu'}</div>
        {NAV.map(({ to, icon, label }) => (
          <NavLink key={to} to={to}
            className={({ isActive }) => `sidebar__link ${isActive ? 'sidebar__link--active' : ''}`}
            title={collapsed ? label : undefined}>
            <span className="sidebar__link-icon">{icon}</span>
            {!collapsed && <span className="sidebar__link-label">{label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="sidebar__footer">
        <div className="sidebar__user">
          <div className="sidebar__user-avatar-wrap">
            <img src="/images/admin/admin-avatar.jpg" alt={admin?.name || 'Admin'} className="sidebar__user-avatar-img"
              onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }}/>
            <div className="sidebar__user-avatar" style={{ display:'none' }}>
              {admin?.name?.split(' ').map(n=>n[0]).join('').slice(0,2) || 'AD'}
            </div>
          </div>
          {!collapsed && (
            <div className="sidebar__user-info">
              <p className="sidebar__user-name">{admin?.name || 'Admin'}</p>
              <p className="sidebar__user-role">{admin?.role || 'Administrator'}</p>
            </div>
          )}
        </div>
        {!collapsed && (
          <button className="sidebar__logout" title="Sign Out" onClick={logout}>
            <LogOut size={15}/>
          </button>
        )}
      </div>

      <button className="sidebar__collapse"
        onClick={() => setCollapsed(c => !c)}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
        {collapsed ? <ChevronRight size={14}/> : <ChevronLeft size={14}/>}
      </button>
    </aside>
  );
}